<template>
  <div>
    <p v-orphans class="d-inline sz-primary-grey--text" v-html="text" />
    <v-expand-transition v-if="additionalText">
      <p v-show="showDetails" v-orphans v-html="additionalText" />
    </v-expand-transition>
    <a
      v-if="additionalText"
      class="d-block primary-link cursor-pointer"
      @click.prevent.stop="toggleDetails"
    >
      {{ buttonLabel }}
    </a>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'

type Props = {
  text: string
  additionalText?: string
}

defineProps<Props>()

const { t } = useI18n()

const showDetails = ref<boolean>(false)

const buttonLabel = computed<string>(() =>
  showDetails.value ? t('label.collapse') : t('label.details')
)

const toggleDetails = (): void => {
  showDetails.value = !showDetails.value
}
</script>
